

























































import { Component, Vue } from 'vue-property-decorator';
import hexabaseState from '@/store/hexabase';
import Matter from '@/models/matterModel';
import { FieldChildrenProp } from '@/services/hexabase/types';
import {
  SearchPanelColumnWidth,
  ProjectSearchExclusionStatus
} from '@/constants/matter/matterList';
import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import BulkStatusActionDialog from '@/components/common/modules/BulkStatusActionDialog.vue';
import DialogData from '@/components/common/modules/DialogData.vue';
//サービス種別
import SelectSearch from '@/components/common/modules/SelectSearch.vue';
//定義
import {
  selectSearchInfo,
  narrowDownSelectOption,
  buttonItems
} from '@/constants/components/matterList';
@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    BulkStatusActionDialog,
    DialogData,
    SelectSearch
  }
})
export default class MatterList extends Vue {
  private matter = new Matter();
  // アプリIDをセット
  private projectId = hexabaseState.applicationId;
  private SelectSearch = new SelectSearch();
  // dbID格納プロパティ
  private mainDsId = '';
  private selectValue = '';
  // マスタデータ関連格納プロパティ
  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
  // 各入力フィールド情報格納プロパティ
  private searchFieldsData: Array<FieldChildrenProp> = [];
  private searchFieldCols = '';
  private statusList: any = {};
  //serviceTypeCom
  private serviceTypeComodityCol: any = {};
  private serviceTypeComodityBody: any = [];
  // 一覧表示部分に使用
  private fieldsData: any = {};
  private colums: Array<{ [k: string]: string | number }> = [];
  private apiResult = false;
  private selectSearchInfo = selectSearchInfo;
  private narrowDownSelectOption = narrowDownSelectOption;
  private SearchPanelColumnWidth = SearchPanelColumnWidth;

  // 検索条件で除外するステータス
  private exclusionStatus = ProjectSearchExclusionStatus;

  private execAllowActions: any = [];

  private buttonItems = buttonItems;
  private defaultDisp = '';

  async created() {
    try {
      // ローディングをセット
      // API通信は子コンポーネント内で行っているためローディングのタイミングは子コンポーネントに記載
      // this.$store.commit("hexabase/setIsLoading", true);
      // データストア情報セット
      this.mainDsId = hexabaseState.datastoreIds['案件基本情報'];
      //サービス種別デフォルト
      const [masterData, execAllowActions] = await Promise.all([
        this.matter.getListMasterData(),
        this.matter.getNewActionList(this.mainDsId).then(data => data.actions)
      ]);
      // マスターデータを取得しグローバル変数に格納
      this.masterData = this.matter.getMaster();
      this.execAllowActions = execAllowActions;
      //サービス種別一覧を取得
      this.serviceTypeComodityCol = this.masterData['m_service_type']['columns'];
      // サービス種別のマスタ情報に使用するデータレポートがない場合、
      // そのサービス種別はマスタ参照のダイヤログに表示させない
      const filterItem = this.masterData['m_service_type']['body'].filter((item:any) =>{
        if (item['data_report_id_for_project_search'] !== '' && item['data_report_id_for_project_search'] !== undefined) {
          return item;
        }
      });
      //デフォルトサービス種別をセット
      this.defaultDisp = filterItem[0].title;

      this.serviceTypeComodityBody = filterItem;
      this.serviceTypeComodityCol.push();
      this.serviceTypeComodityBody.push();
    } catch (e) {
      console.log(e);
      // created内でエラーが発生した場合、ローディングを止める
      this.$store.commit('hexabase/setIsLoading', false);
      this.setError(e);
    } finally {
      // API通信は子コンポーネント内で行っているためローディングのタイミングは子コンポーネントに記載
      // this.$store.commit("hexabase/setIsLoading", false);
    }
  }
  private catchInput(response: any): void {
    this.selectValue = response.value;
  }
  private createMatterRegister(event: any) {
    this.$router.push({ name: 'MatterRegister' });
  }

  private setError(errorMessage: string): void {
    if (typeof errorMessage === 'object') errorMessage = this.matter.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }
}
